var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cusParam_configData
    ? _c("div", { class: "adjust_candidate " + _vm.randomClass }, [
        !_vm.cusParam_simple
          ? _c("div", { staticClass: "top" }, [
              _c("div", { staticClass: "title_area" }, [
                _c("span", { staticClass: "title" }, [_vm._v("候选人调整")]),
                _vm._v(" "),
                _c("div", { staticClass: "search_box" }, [
                  _c("i", {
                    staticClass: "kdfont kdfont-f",
                    on: {
                      click: function($event) {
                        _vm.filterSeaKey = _vm.searchKey.trim()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchKey,
                        expression: "searchKey"
                      }
                    ],
                    attrs: { type: "text", placeholder: "搜索候选人姓名" },
                    domProps: { value: _vm.searchKey },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.filterSeaKey = _vm.searchKey.trim()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchKey = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "overview_area" }, [
                _c("div", { staticClass: "overview_nums" }, [
                  _c(
                    "div",
                    {
                      class: { selected: _vm.filterAnsState === null },
                      on: {
                        click: function($event) {
                          _vm.filterAnsState = null
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          已安排候选人数：" +
                          _vm._s(
                            _vm.cusParam_configData.alreadyArrangeTotalNums
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { selected: _vm.filterAnsState === "A" },
                      on: {
                        click: function($event) {
                          _vm.filterAnsState = "A"
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          未答复人数：" +
                          _vm._s(_vm.cusParam_configData.noAnswerTotalNums) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { selected: _vm.filterAnsState === "C" },
                      on: {
                        click: function($event) {
                          _vm.filterAnsState = "C"
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          不参加人数：" +
                          _vm._s(_vm.cusParam_configData.noAttendTotalNums) +
                          "\n        "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "room_switch" },
                  [
                    _vm._v("\n        展示面试间\n        "),
                    _c("el-switch", {
                      attrs: {
                        activeColor: "var(--theme-color)",
                        "inactive-color": "#c6c6c6"
                      },
                      model: {
                        value: _vm.flodStatus,
                        callback: function($$v) {
                          _vm.flodStatus = $$v
                        },
                        expression: "flodStatus"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "bottom" }, [
          _c(
            "div",
            { staticClass: "date_tab" },
            _vm._l(_vm.cusParam_configData.specialArrTimeDateList, function(
              item,
              index
            ) {
              return _c(
                "div",
                {
                  staticClass: "date_item",
                  class: { selected: _vm.curSpecialDayIndex === index },
                  on: {
                    click: function($event) {
                      return _vm.selectSpecialDay(index)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.dateFormat("MM月dd日", item)) + "\n      ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          !_vm.cusParam_simple
            ? _c("div", { staticClass: "color_tips" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.cusParam_simple && _vm.flodStatus
            ? _c("div", { staticClass: "table_content" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table_body" },
                  _vm._l(_vm.curSiteRoomList, function(itemSite, indexSite) {
                    return _c("div", { staticClass: "table_item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "item_sitetime",
                          staticStyle: { width: "20%" }
                        },
                        [_vm._v(_vm._s(itemSite.specialArrTimeRange))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "item_rooms",
                          staticStyle: { width: "80%" }
                        },
                        _vm._l(
                          itemSite.specialArrTimeRoomAndAppfileListEntitys,
                          function(itemRoom, indexRoom) {
                            return _c("div", { staticClass: "item_roomitem" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "item_intvroom",
                                  staticStyle: { width: "10%" }
                                },
                                [_vm._v(_vm._s(itemRoom.roomName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "item_intver",
                                  staticStyle: { width: "20%" }
                                },
                                [
                                  _c("span", { staticClass: "master_tip" }, [
                                    _vm._v("（主）")
                                  ]),
                                  _vm._v(_vm._s(itemRoom.intverNames))
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "item_candidate",
                                  staticStyle: { width: "50%" }
                                },
                                [
                                  _c("DragGroup", {
                                    attrs: {
                                      dragType: "room",
                                      curSpecialDayIndex:
                                        _vm.curSpecialDayIndex,
                                      indexSite: indexSite,
                                      indexRoom: indexRoom,
                                      appfiles: itemRoom.specialArrAppfileList,
                                      filterAnsState: _vm.filterAnsState,
                                      filterSeaKey: _vm.filterSeaKey,
                                      cusParam_configData:
                                        _vm.cusParam_configData,
                                      cusParam_rejectRsn: _vm.cusParam_rejectRsn
                                    },
                                    on: {
                                      "update:appfiles": function($event) {
                                        return _vm.$set(
                                          itemRoom,
                                          "specialArrAppfileList",
                                          $event
                                        )
                                      },
                                      siteAppfileOp: _vm.siteAppfileOp
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "item_arranged",
                                  class: {
                                    redTip:
                                      itemRoom.specialArrAppfileList.length >
                                      itemRoom.mostArrangeNums
                                  },
                                  staticStyle: { width: "10%" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      itemRoom.specialArrAppfileList.length
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "item_morearrange",
                                  staticStyle: { width: "10%" }
                                },
                                [_vm._v(_vm._s(itemRoom.mostArrangeNums))]
                              )
                            ])
                          }
                        ),
                        0
                      )
                    ])
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.cusParam_simple && !_vm.flodStatus
            ? _c("div", { staticClass: "table_content" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table_body" },
                  _vm._l(_vm.curSiteList, function(itemSite, indexSite) {
                    return _c("div", { staticClass: "table_item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "item_sitetime",
                          staticStyle: { width: "10%" }
                        },
                        [_vm._v(_vm._s(itemSite.specialArrTimeRange))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "item_intvroom",
                          staticStyle: { width: "10%" }
                        },
                        [_vm._v(_vm._s(itemSite.roomNums))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "item_candidate",
                          staticStyle: { width: "60%" }
                        },
                        [
                          _c("DragGroup", {
                            attrs: {
                              dragType: "site",
                              curSpecialDayIndex: _vm.curSpecialDayIndex,
                              indexSite: indexSite,
                              appfiles: itemSite.allArrAppfileList,
                              filterAnsState: _vm.filterAnsState,
                              filterSeaKey: _vm.filterSeaKey,
                              cusParam_configData: _vm.cusParam_configData,
                              cusParam_rejectRsn: _vm.cusParam_rejectRsn
                            },
                            on: {
                              "update:appfiles": function($event) {
                                return _vm.$set(
                                  itemSite,
                                  "allArrAppfileList",
                                  $event
                                )
                              },
                              siteAppfileOp: _vm.siteAppfileOp
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "item_arranged",
                          class: {
                            redTip:
                              itemSite.allArrAppfileList.length >
                              itemSite.allMostArrangeNums
                          },
                          staticStyle: { width: "10%" }
                        },
                        [_vm._v(_vm._s(itemSite.allArrAppfileList.length))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "item_morearrange",
                          staticStyle: { width: "10%" }
                        },
                        [_vm._v(_vm._s(itemSite.allMostArrangeNums))]
                      )
                    ])
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.cusParam_simple
            ? _c("div", { staticClass: "table_content" }, [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table_body" },
                  _vm._l(_vm.curSiteRoomList, function(itemSite, indexSite) {
                    return _c("div", { staticClass: "table_item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "item_sitetime",
                          staticStyle: { width: "30%" }
                        },
                        [_vm._v(_vm._s(itemSite.specialArrTimeRange))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "item_rooms",
                          staticStyle: { width: "70%" }
                        },
                        _vm._l(
                          itemSite.specialArrTimeRoomAndAppfileListEntitys,
                          function(itemRoom, indexRoom) {
                            return _c("div", { staticClass: "item_roomitem" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "item_intvroom",
                                  staticStyle: { width: "50%" }
                                },
                                [_vm._v(_vm._s(itemRoom.roomName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "item_intver",
                                  staticStyle: { width: "50%" }
                                },
                                [
                                  _c("span", { staticClass: "master_tip" }, [
                                    _vm._v("（主）")
                                  ]),
                                  _vm._v(_vm._s(itemRoom.intverNames))
                                ]
                              )
                            ])
                          }
                        ),
                        0
                      )
                    ])
                  }),
                  0
                )
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noreply" }, [
      _c("span", { staticClass: "noreply_color" }),
      _c("span", [_vm._v("候选人未答复")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "join" }, [
      _c("span", { staticClass: "join_color" }),
      _c("span", [_vm._v("候选人参加")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nojoin" }, [
      _c("span", { staticClass: "nojoin_color" }),
      _c("span", [_vm._v("候选人不参加")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table_head" }, [
      _c("span", { staticStyle: { width: "20%", "text-align": "center" } }, [
        _vm._v("场次")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "stretch",
            position: "relative",
            width: "80%"
          }
        },
        [
          _c("span", { staticStyle: { width: "10%" } }, [_vm._v("面试间")]),
          _vm._v(" "),
          _c("span", { staticStyle: { width: "20%" } }, [_vm._v("面试官")]),
          _vm._v(" "),
          _c("span", { staticStyle: { width: "50%" } }, [_vm._v("候选人")]),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { width: "10%", "text-align": "center" } },
            [_vm._v("已安排候选人数")]
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { width: "10%", "text-align": "center" } },
            [_vm._v("最多可安排候选人数")]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table_head" }, [
      _c("span", { staticStyle: { width: "10%", "text-align": "center" } }, [
        _vm._v("场次")
      ]),
      _vm._v(" "),
      _c("span", { staticStyle: { width: "10%" } }, [_vm._v("面试间数量")]),
      _vm._v(" "),
      _c("span", { staticStyle: { width: "60%" } }, [_vm._v("候选人")]),
      _vm._v(" "),
      _c("span", { staticStyle: { width: "10%", "text-align": "center" } }, [
        _vm._v("已安排候选人数")
      ]),
      _vm._v(" "),
      _c("span", { staticStyle: { width: "10%", "text-align": "center" } }, [
        _vm._v("最多可安排候选人数")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table_head" }, [
      _c("span", { staticStyle: { width: "30%", "text-align": "center" } }, [
        _vm._v("场次")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "stretch",
            position: "relative",
            width: "70%"
          }
        },
        [
          _c("span", { staticStyle: { width: "50%" } }, [_vm._v("面试间")]),
          _vm._v(" "),
          _c("span", { staticStyle: { width: "50%" } }, [_vm._v("面试官")])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }